import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ITagsParams } from '../types/actionParams';

export class AddTagsToFlowsRequest extends Request<ITagsParams, IResult> {
  constructor(ids: string[], tags: string[]) {
    super('addTagsToFlows', {
      ids: ids,
      tags: tags
    });
  }
}
